import React, { useState } from "react";

export default function AutoVideo({ srcMp4, srcWebm, poster, className = "" }) {
  const [error, setError] = useState(false);

  // ✅ Fallback to poster image if video missing or error loading
  if (error || !srcMp4) {
    return (
      <div
        className={`rounded-2xl border border-neutral-200 overflow-hidden ${className}`}
      >
        {poster ? (
          <img
            src={poster}
            alt="Product preview"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-neutral-100 flex items-center justify-center text-neutral-400 text-sm">
            No media available
          </div>
        )}
      </div>
    );
  }

  // ✅ Otherwise render video
  return (
    <div
      className={`rounded-2xl border border-neutral-200 overflow-hidden ${className}`}
    >
      <video
        className="w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={poster}
        onError={() => setError(true)} // 👈 triggers fallback automatically
      >
        {srcWebm && <source src={srcWebm} type="video/webm" />}
        <source src={srcMp4} type="video/mp4" />
        Your browser doesn’t support embedded videos.
      </video>
    </div>
  );
}
